/**
 * The transcript card-body frame style (playground CardRenderer wrapper).
 *
 * Most cards keep a defensive `max-height: 80vh` with an inner scroll, BUT an
 * a2ui SURFACE grows to its content — no inner scroll, the transcript (the page)
 * scrolls — like every other session card. A tall a2ui answer otherwise renders
 * ~8 rows behind its own scrollbar (dev-szj playground). The raw-JSON dump
 * (showRaw) keeps the cap. Kept out of PlaygroundView.jsx so the two transcript
 * frames stay in sync and react-refresh keeps that file component-only.
 */
export function cardBodyFrameStyle(card, showRaw) {
  const base = { background: '#fff', color: '#111' };
  const isA2uiSurface = card?.template === 'a2ui_surface' || Array.isArray(card?.data?.envelopes);
  if (isA2uiSurface && !showRaw) return base; // grow to content; the page scrolls
  return { ...base, maxHeight: '80vh', overflow: 'auto' };
}
